// reducers.ts
import { AppActionTypes, SET_RULES_DATA, SET_RULES_DATA_CONDITION, SET_RULES_LEGALITY_VALUE, SET_VALUE } from './rules';

interface AppState {
    data: any;
    rulesData: any;
    rules: any;
    rule_condition_data: any;
}

const initialState: AppState = {
    data: [],
    rulesData: [],
    rules: [],
    rule_condition_data: []
};

const RulesReducer = (state = initialState, action: AppActionTypes): AppState => {
    switch (action.type) {
        case SET_VALUE:
            return {
                ...state,
                data: action.payload
            };
        case SET_RULES_LEGALITY_VALUE:
            return {
                ...state,
                rulesData: action.payload
            };
        case SET_RULES_DATA:
            return {
                ...state,
                rules: action.payload
            };
        case SET_RULES_DATA_CONDITION:
            return {
                ...state,
                rule_condition_data: action.payload
            };

        default:
            return state;
    }
};

export default RulesReducer;
